import type { HTMLAttributes } from "react";
import { Inbox } from "lucide-react";

type EmptyProps = HTMLAttributes<HTMLDivElement> & {
  description?: string;
  layout?: "stacked" | "inline";
  hint?: string;
};

/** shadcn 风格空状态，支持默认居中和紧凑横向两种布局。 */
export function Empty({ description = "暂无数据", layout = "stacked", hint = "有新的分享后会显示在这里", className = "", ...props }: EmptyProps) {
  return <div data-slot="empty" data-layout={layout} className={`fm-shadcn-empty ${className}`.trim()} {...props}>
    <span aria-hidden="true"><Inbox /></span>
    <div className="fm-shadcn-empty-copy"><p>{description}</p><small>{hint}</small></div>
  </div>;
}
